import React, { useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';
import FilterListWrapper from 'core/FiltersDialog/components/FiltersListWrapper';
import { useDialogContext, useFiltersContext } from 'core/FiltersDialog/FiltersDialogContext';
import { get } from 'lodash';

import { Chip, InfiniteScroll } from 'components/v2';

import FilterEmptyState from '../FilterEmptySate';

interface FilterInsuranceListProps {
  data: any;
  type: string;
}

type TPaginationState = {
  hasNext: boolean;
  list: Array<string>;
  page: number;
};

const FilterInsuranceList: React.FC<FilterInsuranceListProps> = ({ data, type }) => {
  const [pagination, setPagination] = useState<TPaginationState>({
    hasNext: data.length > 50,
    list: data.slice(0, 50),
    page: 1,
  });

  const { filters, updater } = useFiltersContext();
  const { toggleLockFilters } = useDialogContext();

  // Force re-render on search
  useEffect(() => {
    setPagination({
      hasNext: data.length > 50,
      list: data.slice(0, 50),
      page: 1,
    });
  }, [data]);

  const handlePagination = () => {
    const nextPageIndex = pagination.page * 50;
    setPagination({
      hasNext: pagination.list.length < data.length,
      list: [...pagination.list, ...data.slice(nextPageIndex, nextPageIndex + 50)],
      page: pagination.page + 1,
    });
  };

  const handleSelectItem = (item: any) => {
    updater(type)(item);
    toggleLockFilters(false);
  };

  const isSelected = (planName: string) =>
    (filters[type].includes('all') && !filters[type].includes(planName)) ||
    (filters[type].includes('all') && filters[type].length === 1) ||
    (!filters[type].includes('all') && filters[type].includes(planName));

  return (
    <FilterListWrapper>
      <InfiniteScroll hasNext={pagination.hasNext} isLoadingNext={false} loadNext={handlePagination}>
        <Grid container spacing={8}>
          {get(pagination, 'list.length', 0) === 0 ? (
            <FilterEmptyState />
          ) : (
            pagination.list.map((item: any) => (
              <Grid item key={item}>
                <Chip
                  color="supportPowder"
                  label={item}
                  selected={isSelected(item)}
                  onClick={() => handleSelectItem(item)}
                />
              </Grid>
            ))
          )}
        </Grid>
      </InfiniteScroll>
    </FilterListWrapper>
  );
};

export default FilterInsuranceList;
